module.exports = __webpack_public_path__ + "img/img-bg-pqr.89647095.jpg";